import React from "react";
import "../document.css";

const Installation = () => {
  return (
    <div className="installation-page">
      <div className="container">
        <h1 className="page-title">
          ИНСТРУКЦИЯ ПО УСТАНОВКЕ ЭКЗЕМПЛЯРА ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ
          «ИММЕТРИКС» ДЛЯ ЭКСПЕРТНОЙ ПРОВЕРКИ
        </h1>

        <section className="instruction-section">
          <h2 className="section-title">
            I. Инструкция по установке экземпляра программного обеспечения,
            предоставленного для проведения экспертной проверки в виде
            контейнера (далее – «Экземпляр»):
          </h2>
          <p className="section-text">
            Для начала работы с экземпляром, представленным для экспертной
            проверки, необходимо:
          </p>
          <ol className="instruction-list">
            <li>Скачать архив по ссылке https://immetrix.codextech.ru/download_docker</li>
            <li>Разархивировать папку с docker-compose файлом</li>
            <li>Дать доступы скрипту через команду “chmod 777 start.sh”.</li>
            <li>
              Запустить скрипт ./start.sh (он установит Docker и залогинится,
              чтобы можно было скачать образ и запустит compose файл), ввести
              пароль от root, если запросит.
            </li>
            <li>
              Открыть в браузере страницу - localhost
              <ul className="credentials-list">
                <li>
                  <strong>Логин:</strong> test@test.ru
                </li>
                <li>
                  <strong>Пароль:</strong> Qwerty!23456
                </li>
              </ul>
            </li>
          </ol>

          <h3 className="subsection-title">
            Минимальные системные требования для эксплуатации экземпляра:
          </h3>
          <ul className="requirements-list">
            <li>
              <strong>Минимальные требования к серверу "коробки":</strong>
            </li>
            <li>Процессор: 2 ядра x 2 GHz.</li>
            <li>Память: не менее 16 Гб.</li>
            <li>Жесткий диск: SATA SSD, не менее 300 Гб.</li>
            <li>
              Если важна скорость восстановления работы системы в случае выхода
              из строя жесткого диска, то рекомендуется использовать два
              одинаковых SSD-диска, собранных в RAID 1 (либо просто подключенных
              к серверу, чтобы наши сотрудники сами объединили при
              разворачивании коробки).
            </li>
            <li>Исходящий доступ в Интернет.</li>
          </ul>

          <h3 className="subsection-title">
            Рекомендуемые системные требования для эксплуатации экземпляра:
          </h3>
          <ul className="requirements-list">
            <li>Процессор: 2 ядер x 2-3 GHz.</li>
            <li>Память: 16 Гб.</li>
            <li>Жесткий диск: SATA SSD/NVMe SSD, не менее 300 Гб.</li>
            <li>
              Если важна скорость восстановления работы системы в случае выхода
              из строя жесткого диска, то рекомендуется использовать два
              одинаковых SSD-диска, собранных в RAID 1 (либо просто подключенных
              к серверу, чтобы наши сотрудники сами объединили при
              разворачивании коробки).
            </li>
            <li>Исходящий доступ в Интернет.</li>
            <li>
              Если планируется "внешний" доступ (из Интернета) к коробочной CRM,
              то обязательна возможность получения трафика на порты 80 и 443.
            </li>
          </ul>

          <h3 className="subsection-title">
            Программное обеспечение, необходимое для эксплуатации экземпляра:
          </h3>
          <ul className="requirements-list">
            <li>
              ОС Windows 10 x64, Linux Ubuntu 22.04 x64, Android (для мобильной
              версии приложения).
            </li>
            <li>
              Браузеры: Google Chrome, Microsoft Edge, Яндекс Браузер, Opera,
              Mozilla Firefox, Safari.
            </li>
          </ul>
        </section>

        <section className="instruction-section">
          <h2 className="section-title">
            II. Инструкция по доступу к тестовой учетной записи облачной версии
            программного обеспечения:
          </h2>
          <p className="section-text">
            Для начала работы с облачной версией программного обеспечения
            требуется веб-браузер и наличие подключения к интернету. Установка
            дополнительного программного обеспечения на устройство пользователя
            не требуется.
          </p>
          <p className="section-text">
            Для начала работы с тестовой учетной записью облачной версии
            программного обеспечения, необходимо:
          </p>
          <ol className="instruction-list">
            <li>
              Открыть в браузере https://immetrix.codextech.ru/login
              <ul className="credentials-list">
                <li>
                  <strong>Логин:</strong> test@test.ru
                </li>
                <li>
                  <strong>Пароль:</strong> Qwerty!23456
                </li>
              </ul>
            </li>
          </ol>

          <h3 className="subsection-title">
            Минимальные системные требования для облачной версии программного
            обеспечения:
          </h3>
          <ul className="requirements-list">
            <li>ОС Windows 10 x64, Linux Ubuntu 22.04 x64, Android.</li>
            <li>
              Браузеры: Google Chrome, Microsoft Edge, Яндекс Браузер, Opera,
              Mozilla Firefox, Safari.
            </li>
            <li>Исходящий доступ в Интернет:</li>
          </ul>
        </section>

        <section className="instruction-section">
          <h2 className="section-title">
            III. Инструкция по установке экземпляра мобильной версии
            программного обеспечения, предоставленного для проведения экспертной
            проверки (android):
          </h2>
          <p className="section-text">
            Для начала работы с экземпляром, представленным для экспертной
            проверки, необходимо:
          </p>
          <ol className="instruction-list">
            <li>
              Скачать архив по ссылке https://immetrix.codextech.ru/download_app,
              распаковать файл *apk
            </li>
            <li>
              Установить приложение с использованием распакованного файла *apk
            </li>
            <li>
              В открывшемся окне ввести:
              <ul className="credentials-list">
                <li>
                  <strong>Логин:</strong> test@test.ru
                </li>
                <li>
                  <strong>Пароль:</strong> Qwerty!23456
                </li>
              </ul>
            </li>
          </ol>
          <p className="section-text">
            Для работы мобильной версии программного обеспечения требуется
            устройство под управлением Android не ниже 6.0, либо средства
            виртуализации соответствующей среды, а также подключение устройства
            к интернету.
          </p>
        </section>

        <section className="instruction-section">
          <h2 className="section-title">
            IV. Дополнительная информация и контактные данные для связи:
          </h2>
          <ul className="contacts-list">
            <li>
              Сервер, на котором размещены экземпляры ПО для скачивания в целях
              экспертной проверки (включая серверную версию и android),
              инфраструктура обеспечивающая работу облачной версии программного
              обеспечения находятся на территории Российской Федерации по
              адресу: 111024, г. Москва, ул. Авиамоторная, 69 (Data Pro I).
              Провайдером указанной услуги является ООО «Хостинг-технологии» ИНН
              7721833428 на основании заключенного с Заявителем договора от
              11.09.2025 № 2257/427120/25, в соответствии с правовой и
              технической документацией, размещенной в сети Интернет по адресам:
              https://vdsina.ru, https://vdsina.ru/documents.
            </li>
            <li>
              Руководство пользователя (информация, необходимая для
              эксплуатации) размещена в сети Интернет по адресу
              https://codextech.ru/product;
            </li>
            <li>
              При наличии у экспертов вопросов по процессу развертывания,
              установки и настройки экземпляра ПО и его функционирования, можно
              связаться с техническим специалистом Заявителя по номеру +7 (938)
              000-23-47 или адресу электронной почты e.zalaev@codextech.ru;
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Installation;
